<template>
    <section>
        <SideBar />
        <TopBar />
        <div class="content">
            <div class="row justify-content-between align-items-end g-3 mb-5">
                <div class="col-12 col-sm-auto col-xl-10">
                    <h2 class="mb-0">{{ modo }} Print</h2>
                </div>
                <div class="col-12 col-sm-auto col-xl-2">
                    <div class="d-flex">
                        <button class="btn btn-primary px-5 w-100 text-nowrap" type="button" @click="setData">Save</button>
                    </div>
                </div>
            </div>

            <p class="text-danger" v-if="error">{{ error }}</p>

            <div class="row g-5">
                <div class="col-xl-12">
                    <div class="card">
                        <div class="card-body">
                            <div class="row gx-3 gy-4">

                                <div class="col-12">
                                    <h5 class="text-uppercase">Images</h5>
                                    <p class="fs--1 text-muted mb-3">The featured image is the one shown in the collection grid.</p>
                                </div>

                                <div class="col-12 col-md-6 mb-4">
                                    <label class="d-block" for="featuredImg" style="cursor:pointer">
                                        <img class="rounded w-100 slot-image" :src="preview('featuredImg')" alt="Featured" />
                                    </label>
                                    <input class="d-none" id="featuredImg" type="file" accept="image/*" @change="uploadImage($event, 'featuredImg')" />
                                    <p class="fs--1 text-center mt-2 mb-0">
                                        Featured
                                        <span v-if="uploading === 'featuredImg'"> - uploading...</span>
                                    </p>
                                </div>

                                <div class="col-12 col-md-6 mb-4">
                                    <div class="row g-4">
                                        <div class="col-6 col-md-6" v-for="slot in extraSlots" :key="slot.key">
                                            <label class="d-block" :for="slot.key" style="cursor:pointer">
                                                <img class="rounded w-100 slot-image slot-image-sm" :src="preview(slot.key)" :alt="slot.label" />
                                            </label>
                                            <input class="d-none" :id="slot.key" type="file" accept="image/*" @change="uploadImage($event, slot.key)" />
                                            <p class="fs--1 text-center mt-2 mb-0">
                                                {{ slot.label }}
                                                <span v-if="uploading === slot.key"> - uploading...</span>
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-sm-12 col-md-6">
                                    <div class="form-floating">
                                        <input class="form-control" v-model="print.title" type="text" placeholder="Title" />
                                        <label>Title</label>
                                    </div>
                                </div>
                                <div class="col-sm-12 col-md-6">
                                    <div class="form-floating">
                                        <input class="form-control" v-model="print.slug" type="text" placeholder="Slug" />
                                        <label>Slug (leave empty to build it from the title)</label>
                                    </div>
                                </div>

                                <div class="col-sm-12 col-md-4">
                                    <div class="form-floating">
                                        <input class="form-control" v-model.number="print.price" type="number" step="0.01" placeholder="Price" />
                                        <label>Price</label>
                                    </div>
                                </div>
                                <div class="col-sm-12 col-md-4">
                                    <div class="form-floating">
                                        <input class="form-control" v-model.number="print.presale" type="number" step="0.01" placeholder="Pre-sale" />
                                        <label>Pre-sale price (0 = no pre-sale)</label>
                                    </div>
                                </div>
                                <div class="col-sm-12 col-md-4">
                                    <div class="form-floating">
                                        <input class="form-control" v-model.number="print.sale" type="number" step="0.01" placeholder="Sale" />
                                        <label>Sale</label>
                                    </div>
                                </div>

                                <div class="col-sm-12 col-md-6">
                                    <div class="form-floating">
                                        <textarea class="form-control" v-model="print.description_es" placeholder="Description ES" style="height:180px"></textarea>
                                        <label>Description (ES)</label>
                                    </div>
                                </div>
                                <div class="col-sm-12 col-md-6">
                                    <div class="form-floating">
                                        <textarea class="form-control" v-model="print.description_en" placeholder="Description EN" style="height:180px"></textarea>
                                        <label>Description (EN)</label>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
import SideBar from '@/components/SideBarNav.vue'
import TopBar from '@/components/TopBarNav.vue'
import axios from 'axios'

const NO_IMAGE = '/assets/no-image.png'

export default {
    name:'PrintAdminComponent',
    components:{SideBar,TopBar},
    data(){
        return{
            print: {
                title:'', slug:'', price:0, presale:0, sale:0,
                description_es:'', description_en:'',
                featuredImg:'', extra_1:'', extra_2:'', extra_3:''
            },
            extraSlots: [
                {key:'extra_1', label:'Extra 1'},
                {key:'extra_2', label:'Extra 2'},
                {key:'extra_3', label:'Extra 3'}
            ],
            uploading: '',
            error: '',
            modo: this.$route.params.id > 0 ? 'Edit' : 'Create'
        }
    },
    created(){
        if(this.$route.params.id){
            this.getData()
        }
    },
    methods:{
        auth(){
            return {
                'Content-Type' : 'application/json',
                'Authorization' : this.$store.state.token
            }
        },
        preview(slot){
            const path = this.print[slot]
            // 400 from ThumbsController::ALLOWED_WIDTHS. The 800 thumb is a
            // JPEG re-encode that comes out larger than these WebP sources,
            // which are only 533-1066px wide to begin with.
            return path ? this.$url+'/thumb/400/'+path : NO_IMAGE
        },
        getData(){
            axios.get(this.$url+'/printadmin/'+this.$route.params.id, { headers: this.auth() })
            .then((res)=>{
                this.print = res.data
            }).catch((err)=>{
                console.log(err)
            })
        },
        uploadImage(event, slot){
            const file = event.target.files[0]
            if(!file) return

            const form = new FormData()
            form.append('foto', file)
            form.append('slot', slot)
            // Name the file after the slug so uploads stay identifiable.
            form.append('slug', this.print.slug || this.print.title || 'print')

            this.uploading = slot
            this.error = ''
            axios.post(this.$url+'/print-image', form, {
                headers: {
                    'Authorization' : this.$store.state.token
                }
            })
            .then((res)=>{
                // Vue 2 needs an explicit set for reactivity on a fresh key.
                this.$set(this.print, slot, res.data.path)
                this.uploading = ''
            }).catch((err)=>{
                this.uploading = ''
                this.error = (err.response && err.response.data && err.response.data.error)
                    ? err.response.data.error
                    : 'Image upload failed'
            })
        },
        setData(){
            this.error = ''
            axios.post(
                this.$url+(this.modo == 'Create' ? '/print' : '/print/'+this.$route.params.id),
                this.print,
                { headers: this.auth() }
            ).then(()=>{
                this.$router.push({name: 'prints'})
            }).catch((err)=>{
                this.error = (err.response && err.response.data && err.response.data.error)
                    ? err.response.data.error
                    : 'Could not save the print'
            })
        }
    }
}
</script>
<style scoped>
/* fixed boxes so a missing image never collapses the row and
   tall images never run into the slot below */
.slot-image{
    aspect-ratio: 1 / 1;
    object-fit: cover;
    background-color: #f5f5f5;
    display: block;
}
.slot-image-sm{
    aspect-ratio: 1 / 1;
}
</style>
